import { DesgloseSubformWithStore } from './DesgloseSubform';

export const DescuentosSubform = DesgloseSubformWithStore('impuestosAguaDescuentosStore');
